import { render } from "./CASIQuestion.vue?vue&type=template&id=535c4605&scoped=true"
import script from "./CASIQuestion.vue?vue&type=script&lang=js"
export * from "./CASIQuestion.vue?vue&type=script&lang=js"

import "./CASIQuestion.vue?vue&type=style&index=0&id=535c4605&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535c4605"]])

export default __exports__